import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from '@mui/material';
import CustomButton from '../../../common/CustomButton';
import ItemPrice from '../ItemPrice';
const CallToAction = ({ showPrice, showButton, price, sellPrice, action, buttonLabel, isFlexGrow, variant, }) => (_jsxs(Stack, { direction: "row", justifyContent: "flex-end", spacing: 1.25, alignSelf: "center", children: [showPrice && (_jsx(ItemPrice, { variant: "text", price: price, sellPrice: sellPrice })), showButton && action && (_jsx(CustomButton, { variant: variant, label: buttonLabel, className: "cta-button", customStyle: {
                flexGrow: isFlexGrow ? 'inherit' : 0,
            }, onClick: action })), showButton && !action && (_jsx("div", { children: buttonLabel }))] }));
CallToAction.defaultProps = {
    variant: 'outlined',
    showPrice: true,
    showButton: true,
    sellPrice: undefined,
};
export default CallToAction;
//# sourceMappingURL=CallToAction.js.map